export default __webpack_public_path__ + "static/media/IMG_0035_8_11zon.1b347146.jpg";